<template>
  <div id="body" class="p-4 bg-gray-50 min-h-screen">
    <base-navigation></base-navigation>

    <base-card class="shadow-lg rounded-2xl p-6 bg-white">
      <div id="element-to-convert">
        <!-- Header -->
        <!-- <div class="row align-items-center mb-4">
          <div class="col-lg-6 text-center">
            <img
              width="140"
              height="120"
              src="../../assets/twiga_logo.png"
              alt="Twiga Logo"
              class="rounded-lg shadow-sm"
            />
          </div>

          <div class="col-lg-6 text-lg-right">
            <h2 class="font-bold text-primary mb-1">Twiga Court Residents Association</h2>
            <p class="text-muted mb-2">
              <strong>2025 Membership Security and Development Payments</strong>
            </p>

            <p class="text-primary font-medium">
              If your name is not in the list, make payment to MPESA Paybill
              <strong>542542</strong>, Account <strong>38458</strong>.
            </p>
            <p class="text-danger font-semibold">
              Otherwise, pick a key and open for yourself and your visitors when they come.
            </p>
          </div>
        </div> -->

        <!-- Report Info -->
        <div class="row mb-4 border-bottom pb-2">
          <div class="col-lg-7">
            <h6 class="font-semibold text-gray-800">Members who receives security services</h6>
          </div>
          <div class="col-lg-5 text-right text-info">
            <h5 class="font-medium">Date: 
              <span class="text-dark">
                {{ new Date().toLocaleString("nl-NL").split(",")[0] }}
              </span>
            </h5>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-bordered table-striped text-center align-middle">
            <thead class="thead-dark">
              <tr>
                <th class="py-3">No.</th>
                <th class="py-3">Name</th>
                <th class="py-3">Phone</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(member, index) in paidMembers" :key="member.id">
                <td class="py-2 text-lg font-medium">{{ index + 1 }}</td>
                <td class="py-2 text-lg">{{ member.member_name }}</td>
                <td><small>07***{{ member.member_phone.toString().slice(-3) }}</small></td>

                <!-- <td class="py-2 text-lg">{{ member.member_phone }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
         </div>

        <div class="text-center mt-6">
          <button
            @click="exportToPDF"
            class="btn btn-success px-4 py-2 text-lg font-bold rounded-lg shadow"
          >
            Download PDF
          </button>
          <br /><br />
          <router-link to="/" class="text-primary font-medium text-lg">
            Go back
          </router-link>
        </div>
     
    </base-card>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  methods: {
exportToPDF() {
  const element = document.getElementById("element-to-convert");

  const style = document.createElement("style");
  style.innerHTML = `
    #element-to-convert, #element-to-convert * {
      font-size: 22px !important;  /* realistic big print size */
      color: #000 !important;
    }
    #element-to-convert th, #element-to-convert td {
      padding: 3px 6px !important;
      line-height: 1.1 !important;
    }
  `;
  document.head.appendChild(style);

  const opt = {
    margin: [10, 10, 10, 10],
    filename:
      "Twiga_Court_Report_" + new Date().toLocaleDateString("nl-NL") + ".pdf",
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
      scale: 4, // ← increase scale for sharper, larger render
      useCORS: true,
      scrollY: 0,
      windowWidth: element.scrollWidth,
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
      compressPDF: false,
    },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  html2pdf()
    .set(opt)
    .from(element)
    .save()
    .then(() => {
      document.head.removeChild(style);
    });
}


  },

  computed: {
    memberdetails() {
      return this.$store.getters.allMembers;
    },
    paidMembers() {
      return this.$store.getters.allMembers.filter(
        (col) => col.processed == 1
      );
    },
  },

  created() {
    this.$store.dispatch("LoadMembers");
    this.$store.dispatch("LoadPayments");
    this.$store.dispatch("LoadNewmembers");
    this.$store.dispatch("LoadCases");
    this.$store.dispatch("LoadExpenses");
  },
};
</script>

<style scoped>
#body {
  font-family: "Poppins", sans-serif;
}

h2,
h4,
h5
h6 {
  color: #0b3d91;
}

p,
td,
th,
span {
  font-size: 14px;
}

.table {
  border-radius: 8px;
  overflow: hidden;
}

.table th {
  background-color: #0b3d91;
  color: white;
  font-size: 14px;
}

.table td {
  font-size: 14px;
}

.text-primary {
  color: #0056b3 !important;
}
.text-danger {
  color: #dc3545 !important;
}
.text-info {
  color: #17a2b8 !important;
}

button.btn-success {
  background-color: #198754;
  border: none;
}
button.btn-success:hover {
  background-color: #157347;
}
/* Prevent table rows from being split between PDF pages */
table, tr, td, th {
  page-break-inside: avoid !important;
}

/* Add space at the bottom of each page */
#element-to-convert {
  margin: 6px;
  padding: 20px;
}

/* Prevent text cutoff at the bottom */
@media print {
  body {
    /* -webkit-print-color-adjust: exact !important; */
    margin: 20mm !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  tr {
    page-break-inside: avoid !important;
  }
}
#element-to-convert table {
  border-collapse: collapse !important;
  width: 100%;
}

#element-to-convert th,
#element-to-convert td {
  padding: 10px 10px !important; /* reduce cell spacing */
  line-height: 1.1 !important; /* tighter line spacing */
  vertical-align: middle !important;
}

#element-to-convert tr {
  margin: 14 !important;
}

#element-to-convert {
  font-size: 40px !important; /* keep your current font size */
}
</style>
